import { render, staticRenderFns } from "./Disability.vue?vue&type=template&id=2ab6c772"
import script from "./Disability.vue?vue&type=script&lang=js"
export * from "./Disability.vue?vue&type=script&lang=js"
import style0 from "./Disability.vue?vue&type=style&index=0&id=2ab6c772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports